import api from './index'
import { axios } from '@/utils/request'
import { BaseURL } from "@/utils/config"

export function getLogUserById(parameter) {
    return axios({
        url: BaseURL +  api.Log + 'get_log_user',
        method: 'GET',
        params: parameter
    })
}
export function checkRelease(parameter) {
    return axios({
        url: BaseURL +  api.Log + 'check_release_status',
        method: 'GET',
        params: parameter
    })
}